import React from 'react';
import { P } from '@fashionnovateam/nova-ui-toolkit';
import Steps from './Steps';

type StepSectionProps = {
  stepNumber: string;
  stepTitle: string;
  steps?: { id: string; text: React.ReactNode }[];
  stepDescription?: React.ReactNode;
};

function StepSection({
  stepNumber,
  stepTitle,
  stepDescription,
  steps,
}: StepSectionProps) {
  return (
    <div className="mt-10">
      <P size="xs" color="secondary" weight="semibold">
        {stepNumber}
      </P>
      <P size="2xl" weight="medium" className="mt-3">
        {stepTitle}
      </P>
      {stepDescription && (
        <P size="md" color="secondary" className="mt-3">
          {stepDescription}
        </P>
      )}
      {steps && steps.length > 0 && (
        <div className="mt-5">
          {steps.map((step, index) => (
            <Steps
              key={step.id}
              stepNumber={index + 1}
              stepText={step.text}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default StepSection;
